import { ChangeDetectorRef, Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';
import { UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import * as _ from 'lodash';
import { ICountry } from '../countries.interface';
import { CountriesService } from '../countries.service';
import { map } from 'rxjs';
import { CurrenciesService } from '../../../currencies-page/currencies/currencies.service';
import { AuthService } from '../../../../shared/services/auth.service';
import { ICurrencyFilter } from '../../../currencies-page/currencies/currencies.interface';

let self: any;

@Component({
  selector: 'app-countries-modal',
  templateUrl: './countries-modal.component.html',
  styleUrls: ['./countries-modal.component.css']
})
export class CountriesModalComponent implements OnInit {
  dialog: MatDialogRef<any>;
  readOnly: boolean = true;
  loading: boolean = false;
  saving: boolean = false;
  country!: ICountry;
  form!: UntypedFormGroup;
  submitted = false;
  currencies: any[] = [{ value: undefined, label: 'seleccione moneda' }];
  isDev!: boolean;

  constructor(
    public _CountriesService: CountriesService,
    public _CurrenciesService: CurrenciesService,
    public dialogRef: MatDialogRef<any>,
    private fb: UntypedFormBuilder,
    private _AuthService: AuthService
  ) {
    self = this;
    this.dialog = dialogRef;
  }

  ngOnInit(): void {
    this.isDev = this._AuthService.isRole('dev');

    let currFilter: ICurrencyFilter = {
      filters: { isDeleted: false },
      skip: 0,
      limit: 10000,
      sort: 'name'
    };
    this._CurrenciesService.getCurrencies(currFilter).pipe(
      map(el => el.map(cur => ({ value: cur._id, label: cur.name })))
    ).subscribe((currencies) => {
      this.currencies = this.currencies.concat(currencies);
      if (this.country._id) this.getCountry();
      else this.buildForm();
    });
  }

  getCountry() {
    this.loading = true;
    this._CountriesService.getCountry(this.country._id || '').subscribe((country) => {
      this.country = country;
      this.buildForm();
      this.loading = false;
    });
  }

  get f() { return this.form.controls; }
  buildForm() {
    const currency = _.get(this.country, 'currency._id');
    this.form = this.fb.group({
      _id: [this.country._id],
      name: [this.country.name, [Validators.required]],
      currency: [currency, [Validators.required]],
      isDeleted: [this.country.isDeleted]
    });
  }

  setEditable() {
    this.readOnly = false;
  }

  onSubmit() {
    this.submitted = true;
    let data: ICountry = _.cloneDeep(this.form.value);
    if (this.form.invalid) return;
    this.saving = true;
    if (this.country._id) {
      data._id = this.country._id;
      this._CountriesService.updateCountry(data).subscribe((country) => {
        this.dialog.close(country);
      });
    } else {
      this._CountriesService.createCountry(data).subscribe((country) => {
        this.dialog.close(country);
      });
    }
  }
}